import { Flex, Heading, Image } from "@chakra-ui/react";
import {
    createBrowserRouter
} from "react-router-dom";
import Logo from '../common/assets/logo.jpeg';
import { AuthProvider } from "../context/AuthContext/AuthProvider";

export type NavLink = {
    path: string,
    label: string
}

export const NAV_LINKS: NavLink[] = []

export const AppRouter = createBrowserRouter([
    {
        path: '/',
        element: <AuthProvider>
            <Flex height='100vh' width='100vw' justifyContent='center' alignItems='center' flexDirection='column' bgColor='#f4f4f4'>
                <Image src={Logo} boxSize='250px' borderRadius='full'/>
                <Heading fontFamily='serif' fontSize='large' marginBottom='16px'>online store</Heading>
                <Heading fontFamily='serif' fontSize='x-large'>Coming Soon</Heading>
            </Flex>
        </AuthProvider>
    },
])

